export function selectionSummary(
  loading: boolean,
  total: number,
  selected: number,
  plural: string,
  singular?: string
) {
  if (loading) return `Laddar ${plural}…`;
  if (total === 0) return `Inga ${plural}`;
  return `Visar ${selected} av ${total} ${plural}`;
}
